4<template>
  <b-card no-body>
    <!-- <DialogHeader name="fontawesome"></DialogHeader> -->
    <b-card-header class="p-0 p-md-1">
      <b-row class="p-2 text-white">
        <b-col class="col-12 col-lg-6">
          <span class="mb-3 font-weight-bold" style="font-size:1.2em;">21대 국회 의석수 계산기</span>
        </b-col>
        <b-col class="col-12 col-lg-6 text-right">
          <span class="mb-3">최종업데이트 : {{ lastModified }}</span>
        </b-col>
      </b-row>

      <b-row class="p-2">
        <b-col class="col-3 col-md-2 col-lg-2">
          개표 및 출구조사
        </b-col>
        <b-col class="col-9 col-md-10 col-lg-10">

          <b-button
            class="col-poll ml-2 mx-1 mt-1 mb-3"
            size="sm"
            variant="danger"
            @click.prevent.stop="selectVoteResult(vote_result.FINAL)">
            개표결과<br />
            <small>선거관리위원회</small>
          </b-button>

          <b-button
            class="col-poll ml-2 mx-1 mt-1 mb-3"
            id="summerized-total-tip"
            variant="info"
            size="sm"
            @click.prevent.stop="selectVoteResult({
              proportionalSeat : summarized_proportional_seat_poll,
              localSeat : summarized_local_seat
            });">
            종합 현황<br />
            <small>개표·출구·여론조사</small>
          </b-button>
          <b-tooltip target="summerized-total-tip">현재까지의 개표 및 출구조사와 여론조사 값을 종합하여 판단합니다. 개표 결과가 없을 경우 출구조사로, 출구조사가 없을 경우 여론조사 순으로 계산됩니다.</b-tooltip>

          <b-button
            class="col-poll ml-2 mx-1 mt-1 mb-3"
            id="exitpoll-tip1"
            size="sm"
            @click.prevent.stop="selectVoteResult(vote_result.KBS);">
            출구조사<br />
            <small>KBS</small>
          </b-button>
          <b-tooltip target="exitpoll-tip1">출구조사값이 범위(최대 ~ 최소)일 경우 중간값으로 환산 후 의석수가 다시 계산됩니다.</b-tooltip>

          <b-button
            class="col-poll ml-2 mx-1 mt-1 mb-3"
            id="exitpoll-tip2"
            size="sm"
            @click.prevent.stop="selectVoteResult(vote_result.MBC);">
            출구조사<br />
            <small>MBC</small>
          </b-button>
          <b-tooltip target="exitpoll-tip2">출구조사값이 범위(최대 ~ 최소)일 경우 중간값으로 환산 후 의석수가 다시 계산됩니다.</b-tooltip>

          <b-button
            class="col-poll ml-2 mx-1 mt-1 mb-3"
            id="exitpoll-tip3"
            size="sm"
            @click.prevent.stop="selectVoteResult(vote_result.SBS);">
            출구조사<br />
            <small>SBS</small>
          </b-button>
          <b-tooltip target="exitpoll-tip3">출구조사값이 범위(최대 ~ 최소)일 경우 중간값으로 환산 후 의석수가 다시 계산됩니다.</b-tooltip>

          <!-- <b-button
            class="col-poll ml-2 mx-1 mt-1 mb-3"
            id="exitpoll-tip4"
            size="sm"
            @click.prevent.stop="selectVoteResult(vote_result.JTBC);">
            출구조사<br />
            <small>JTBC</small>
          </b-button>
          <b-tooltip target="exitpoll-tip4">출구조사값이 범위(최대 ~ 최소)일 경우 중간값으로 환산 후 의석수가 다시 계산됩니다.</b-tooltip> -->
        </b-col>
      </b-row>

      <b-row class="p-2 d-none d-xl-flex">
        <b-col class="col-3 col-md-2 col-lg-2">
          지역구 예상 분석
        </b-col>
        <b-col class="col-9 col-md-10 col-lg-10">
          <b-button
            id="summarized-local-seat-tip"
            class="col-poll mx-2 mt-1 mb-1"
            size="sm"
            variant="info"
            @click.prevent.stop="selectLocalSeatSample(summarized_local_seat)">
            지역구 여론조사 종합
          </b-button>
          <b-tooltip target="summarized-local-seat-tip">여론조사를 기반으로 산정한 데이터입니다. 여론조사가 없는 지역구는 여론조사가 진행된 지역구의 정당득표 비율로 다시 계산되었습니다.</b-tooltip>

          <b-button size="sm"
            class="col-poll mx-2 mt-1 mb-1"
            @click.prevent.stop="selectLocalSeatSample(localSeatVote20)"
          >
            20대 의석수 대비
          </b-button>

          <b-button size="sm"
            class="col-poll mx-2 mt-1 mb-1"
            @click.prevent.stop="selectLocalSeatSample(localSeatVote21Sample3)"
          >
            선거위키(2019-03-31)
            <b-badge pill variant="primary" class="col-label"
              @click.stop.prevent="goLink('http://blog.naver.com/PostView.nhn?blogId=electionwiki&logNo=221882112337')">연결
            </b-badge>
          </b-button>

          <b-button size="sm"
            class="col-poll mx-2 mt-1 mb-1"
            @click.prevent.stop="selectLocalSeatSample(localSeatVote21Sample1)"
          >
            선거위키(2019-03-17)
            <b-badge pill variant="primary" class="col-label"
              @click.stop.prevent="goLink('http://blog.naver.com/PostView.nhn?blogId=electionwiki&logNo=221858590924')">연결
            </b-badge>
          </b-button>
          <b-button size="sm"
            class="col-poll mx-2 mt-1 mb-1"
            @click.prevent.stop="selectLocalSeatSample(localSeatVote21Sample2)"
          >
            한국경제(2019-03-11)
            <b-badge pill variant="primary" class="col-label"
              @click.stop.prevent="goLink('https://www.hankyung.com/politics/article/202003112169i')">연결
            </b-badge>
          </b-button>
        </b-col>
      </b-row>

      <b-row class="p-1 d-none d-xl-flex">
        <b-col class="col-3 col-md-2 col-lg-2">
        </b-col>
        <b-col class="col-9 col-md-10 col-lg-10">
          <template v-for="(lspl, index) in local_seat_poll_link">
          <b-button
            :key="index"
            class="col-poll mx-2 mt-1 mb-3"
            size="sm"
            @click.prevent.stop="goLink(lspl.link)">
            {{ lspl.name }}<br />
            <small>{{ lspl.update }}</small>
          </b-button>
          </template>
        </b-col>
      </b-row>
      
      <b-row class="p-2 d-none d-xl-flex">
        <b-col class="col-3 col-md-2 col-lg-2">
          비례의석 여론조사
        </b-col>
        <b-col class="col-9 col-md-10 col-lg-10">
          <b-button
            class="col-poll mx-2 mt-1 mb-3"
            size="sm"
            variant="info"
            @click.prevent.stop="selectProportionalSeatPoll(summarized_proportional_seat_poll)">
            비례대표 여론조사 종합<br />
            <small>3월 22일 ~ 현재</small>
          </b-button>
          <b-badge pill variant="primary" class="col-badge">{{ summarized_proportional_seat_poll.respondent | digit }}명</b-badge>


          <template v-for="(poll, index) in proportional_seat_poll_list">
          <b-button
            :key="index"
            class="col-poll mx-2 mt-1 mb-3"
            size="sm"
            @click.prevent.stop="selectProportionalSeatPoll(poll)">
            {{ poll.requester }}, {{ poll.research }}<br />
            <small>{{ poll.period }}</small>
            <b-badge pill variant="primary" class="col-badge"> {{ poll.respondent | digit }}명</b-badge>
          </b-button>
          </template>
        </b-col>
      </b-row>

      <b-row class="p-1 d-none d-xl-flex">
        <b-col class="col-12 text-right">
          <b-button size="sm" class="mx-1" @click.stop.prevent="goLink('https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EB%B9%84%EB%A1%80%EB%8C%80%ED%91%9C')">비례대표 계산 과정(나무위키)</b-button>
          <b-button size="sm" class="mx-1" @click.stop.prevent="goLink('https://namu.wiki/w/%EB%B6%84%EB%A5%98:%EB%8C%80%ED%95%9C%EB%AF%BC%EA%B5%AD%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0')">지역구 여론조사 출처(나무위키)</b-button>
          <b-button size="sm" class="mx-1" @click.stop.prevent="goLink('https://ko.wikipedia.org/wiki/%EB%8C%80%ED%95%9C%EB%AF%BC%EA%B5%AD_%EC%A0%9C21%EB%8C%80_%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90_%EC%84%A0%EA%B1%B0_%EC%97%AC%EB%A1%A0_%EC%A1%B0%EC%82%AC#5%EC%B0%A8_%EC%A0%95%EA%B3%84_%EA%B0%9C%ED%8E%B8_%EC%9D%B4%ED%9B%84_2')">비례 여론조사 출(위키피디아) </b-button>
          <b-button size="sm" class="mx-1" @click.stop.prevent="goLink('http://www.ohmynews.com/NWS_Web/View/at_pg_w.aspx?CNTN_CD=A0002623791')">지도 정보(오마이뉴스)</b-button>
          <!-- <b-button size="sm" class="mx-1" @click.stop.prevent="goLink('https://github.com/OhmyNews/2020_21_elec_map/blob/master/2020_21_elec_253_simple.json')">지도 정보 : GeoJson</b-button> -->
        </b-col>
      </b-row>
    </b-card-header>

    <b-card-body class="p-0 p-md-1">
      <b-row>
        <b-col class="col-12 px-5">
          <b-container fluid class="p-0">
          <b-row class="text-center py-1" style="font-size:1.1em;border-bottom:1px dashed;">
            <b-col :class="clazz(1)">정당</b-col>
            <b-col :class="clazz(2)">지역구 의석수</b-col>
            <b-col :class="clazz(2)">정당 지지율</b-col>
            <b-col :class="clazz(3)">환산 지지율</b-col>
            <b-col :class="clazz(3)">준연동형 비례</b-col>
            <b-col :class="clazz(3)">병립형 비례</b-col>
            <b-col :class="clazz(4, ['py-1', 'col-poll'])">합계
              <b-badge pill class="col-label">비율</b-badge>
            </b-col>
          </b-row>

          <template v-for="(key, index) in partyKey">
            <b-row :key="key" class="py-2 hover-row" style="border-bottom:1px dashed;">
              <b-col :class="clazz(1, ['py-1', 'col-poll'])">
                <template v-if="partyList[key].no">
                  {{ partyList[key].no }}.
                </template>
                {{ partyList[key].name }}
                <b-badge pill class="col-group" :style="{backgroundColor: partyGroup[partyList[key].group].color}">{{ partyGroup[partyList[key].group].name }}</b-badge>
              </b-col>

              <template v-if="!partyList[key].localLock">
                <b-col :class="clazz(2)">
                  <b-form-input
                    type="number"
                    v-model="input_party[index].localseat"
                    @keyup="calculate"
                    @change="calculate"
                    :disabled="partyList[key].localLock"
                    class="text-right"></b-form-input>
                </b-col>
              </template>
              <template v-else-if="!['part90', 'noparty', 'undecided'].includes(key)">
                <b-col :class="clazz(2, ['text-center', 'py-1'])">지역후보없음</b-col>
              </template>
              <template v-else>
                <b-col :class="clazz(2)"></b-col>
              </template>

              <template v-if="!partyList[key].ratioLock">
                <b-col :class="clazz(2)">
                  <b-form-input
                    type="number"
                    v-model="input_party[index].ratio"
                    @keyup="calculate"
                    @change="calculate"
                    :disabled="partyList[key].ratioLock"
                    class="text-right"></b-form-input>
                </b-col>
              </template>
              <template v-else-if="!['part90', 'noparty', 'undecided'].includes(key)">
                <b-col :class="clazz(2, ['text-center', 'py-1'])">비례후보없음</b-col>
              </template>
              <template v-else>
                <b-col :class="clazz(2)"></b-col>
              </template>

              <b-col :class="clazz(3, ['text-right', 'py-1', 'meaning'])">
                <template v-if="!['part90', 'noparty', 'undecided'].includes(key) && ratio100[key] > 0">
                  <strong :style="{color:partyList[key].color}">{{ ratio100[key] | ratio }}</strong>
                </template>
                <template v-else>
                  -
                </template>
              </b-col>

              <b-col :class="clazz(3, ['text-right', 'py-1', 'meaning'])">
                <template v-if="!['part90', 'noparty', 'undecided'].includes(key) && proportional_seat30[key] > 0">
                  <strong :style="{color:partyList[key].color}">{{ proportional_seat30[key] | digit }}</strong>
                </template>
                <template v-else>
                  -
                </template>
              </b-col>
              <b-col :class="clazz(3, ['text-right', 'py-1', 'meaning'])">
                <template v-if="!['part90', 'noparty', 'undecided'].includes(key) && proportional_seat17[key] > 0">
                  <strong :style="{color:partyList[key].color}">{{ proportional_seat17[key] | digit }}</strong>
                </template>
                <template v-else>
                  -
                </template>
              </b-col>

              <template v-if="!['part90', 'undecided'].includes(key) && seatRatio(index, key) > 0">
                <b-col :class="clazz(4, ['text-right', 'py-1', 'col-poll', 'meaning'])">
                  <strong :style="{color:partyList[key].color}">
                    <span class="mr-4">{{ (readLocalSeat(index) + (proportional_seat30[key] || 0) + (proportional_seat17[key] || 0)) | digit }}</span>
                  </strong>
                  <b-badge
                    pill
                    class="col-percent"
                    v-if="seatRatio(index, key) > 0"
                    :style="{backgroundColor: partyList[key].color}"
                  >
                    {{ seatRatio(index, key) | ratio }}
                  </b-badge>
                </b-col>
              </template>
              <template v-else>
                <b-col :class="clazz(4, ['text-right', 'py-1', 'col-poll', 'meaning'])">
                  <span class="mr-4">-</span>
                </b-col>
              </template>
            </b-row>
          </template>
          <b-row class="mt-1 font-weight-bold">
            <b-col :class="clazz(1)">합계<small>(무당층 제외)</small></b-col>
            <b-col :class="clazz(2)">
                <b-form-input type="number"
                  v-model="input_localseat_total"
                  :disabled="true"
                  aria-describedby="validate-feedback-localseat-total"
                  class="text-right"></b-form-input>
                <!-- {{ getLocalSeatTotal | digit }} -->
            </b-col>
            <b-col :class="clazz(2)">
                <b-form-input type="number" v-model="input_ratio_total" :disabled="true" class="text-right"></b-form-input>
                <!-- {{ getRatioTotal | ratio }} -->
            </b-col>
            <b-col :class="clazz(3, ['text-right'])">
                <!-- <b-form-input type="number" v-model="input_ratio100_total" :disabled="true" class="text-right"></b-form-input> -->
                <!-- {{ input_ratio100_total | ratio }} -->
            </b-col>
            <b-col :class="clazz(3, ['text-right'])">
                <!-- <b-form-input type="number" v-model="input_proportional_seat30_total" :disabled="true" class="text-right"></b-form-input> -->
                {{ input_proportional_seat30_total | digit }}
            </b-col>
            <b-col :class="clazz(3, ['text-right'])">
                <!-- <b-form-input type="number" v-model="input_proportional_seat17_total" :disabled="true" class="text-right"></b-form-input> -->
                {{ input_proportional_seat17_total | digit }}
            </b-col>
            <b-col :class="clazz(4 , ['text-right'])">
                <!-- <b-form-input type="number" v-model="input_seat_total" :disabled="true" class="text-right"></b-form-input> -->
                {{ input_seat_total | digit }}
            </b-col>
          </b-row>
          </b-container>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col class="col-12 col-xl-3">
          <b-row class="mb-5">
            <b-col class="col-12 col-md-6 col-xl-12">
              <vote21-chart
                ref="party_group_chart"
                :chart-data="groupData"
                :options="chartOptions"
                height="400"
                >
              </vote21-chart>
            </b-col>
            <b-col class="col-12 col-md-6 col-xl-12">
              <vote21-chart
                ref="party_seat_chart"
                :chart-data="chartData"
                :options="chartOptions"
                height="400"
                >
              </vote21-chart>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="col-12 col-xl-9">
          <vote21-map
            :party-list="partyList"
            :map-data="merged_local_seat_data"
            :local-seat-data="summarized_local_seat"
            :local-seat-state="summarized_local_state"
          ></vote21-map>
        </b-col>
      </b-row>
      
      <template v-if="false">
      <template v-for="(local_seat_data, key) in merged_local_seat_data">
        <b-row :key="key" class="m-2 mt-3 pt-2 poll-hover-row">
          <b-col class="col-12 text-white">
            <b-row class="mb-1">
              <b-col class="col-12">
                <template v-if="local_seat_data.elected">
                  <span
                    class="p-1 px-3 rounded-pill"
                    :style="{backgroundColor:local_seat_data.elected.color}"
                  >
                    <strong class="text-warning">{{ localcodes[key].SGG_2 }}</strong>
                    <span class="mx-2" :style="{backgroundColor:local_seat_data.elected.color}">
                      <vote21-award :width="24" :height="24"></vote21-award>
                      {{ local_seat_data.elected.partyName }}, {{ local_seat_data.elected.name }}
                    </span>
                  </span>
                </template>
                <template v-else-if="local_seat_data.first">
                  <span
                    class="p-1 px-3 rounded-pill"
                    :style="{backgroundColor:local_seat_data.first.color}"
                  >
                    <strong>{{ localcodes[key].SGG_2 }}</strong>
                    <span class="mx-2" :style="{backgroundColor:local_seat_data.first.color}">
                      {{ local_seat_data.first.partyName }}, {{ local_seat_data.first.name }}
                    </span>
                  </span>
                </template>
                <template v-else>
                  <strong>{{ localcodes[key].SGG_2 }}</strong>
                </template>
              </b-col>
            </b-row>
            
            <b-row class="mb-3" v-if="local_seat_data.final">
              <b-col class="col-12 pl-3">
                <b-row class="mt-1">
                  <b-col class="col-12 col-lg-6 text-white">
                    개표 결과
                  </b-col>
                  <b-col class="col-12 col-lg-6 text-white text-right">
                    <vote21-fire
                      :delta="local_seat_data.final.encounter"
                    ></vote21-fire>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="col-12 text-right">
                    <vote21-ratio-bar
                      :party-list="partyList"
                      :data="local_seat_data.final.data"
                    ></vote21-ratio-bar>
                    <small>
                    </small>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            
            <b-row class="mb-3" v-if="local_seat_data.exitpoll" :style="makeOpacity(local_seat_data.final)">
              <b-col class="col-12 pl-3">
                <b-row class="mt-1">
                  <b-col class="col-12 col-lg-6 text-white">
                    출구 조사
                  </b-col>
                  <b-col class="col-12 col-lg-6 text-white text-right">
                    <vote21-fire
                      :delta="local_seat_data.exitpoll.encounter"
                    ></vote21-fire>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="col-12 text-right">
                    <vote21-ratio-bar
                      :party-list="partyList"
                      :data="local_seat_data.exitpoll.data"
                    ></vote21-ratio-bar>
                  </b-col>
                </b-row>

                <template v-if="!local_seat_data.final">
                  <b-row>
                    <template v-for="(poll, key) in local_seat_data.exitpolls">
                      <b-col :key="key" class="col-4 pl-3">
                        <b-row class="mt-1">
                          <b-col class="col-12 text-white">
                            출구조사 {{ key }}
                          </b-col>
                          <b-col class="col-12 text-right">
                            <vote21-ratio-bar
                              :party-list="partyList"
                              :data="poll"
                            ></vote21-ratio-bar>
                          </b-col>
                        </b-row>
                      </b-col>
                    </template>
                  </b-row>
                </template>

              </b-col>
            </b-row>

            <b-row class="mb-3" v-if="local_seat_data.poll" :style="makeOpacity(local_seat_data.exitpoll)">
              <b-col class="col-12 pl-3">
                <b-row class="mt-1">
                  <b-col class="col-12 col-lg-6 text-white">
                    여론조사 종합
                  </b-col>
                  <b-col class="col-12 col-lg-6 text-white text-right">
                    <vote21-fire :delta="local_seat_data.poll.encounter" :max="6"></vote21-fire>
                  </b-col>
                  <b-col class="col-12 text-right">
                    <vote21-ratio-bar
                      :party-list="partyList"
                      :data="local_seat_data.poll.data"
                    ></vote21-ratio-bar>
                    <small>
                    </small>
                  </b-col>
                </b-row>
              </b-col>


              <template v-if="!local_seat_data.final && !local_seat_data.exitpoll">
                <template v-for="(poll, index) in local_seat_data.polls">
                  <b-col :key="index" class="col-6 col-md-6 col-lg-4 col-xl-3 pl-3">
                    <b-row class="mt-1">
                      <b-col class="col-12 text-white">
                        <template v-if="poll.requester && poll.research">
                          {{ poll.requester }}, {{ poll.research }}
                        </template>
                        <template v-else>
                          {{ poll.requester }} {{ poll.research }}
                        </template>
                      </b-col>
                      <!-- <b-col class="col-12 col-md-7 text-right">
                      </b-col> -->
                      <b-col class="col-12 text-right">
                        <vote21-ratio-bar
                          :party-list="partyList"
                          :data="poll.data"
                        ></vote21-ratio-bar>
                        <small>
                        </small>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2 d-none d-md-block">
                      <b-col class="col-12 pl-3">
                        <small>
                          여론조사기간 : {{ poll.period }}
                          <!-- , {{ poll.respondent | digit }}명 -->
                          , <a href="#" @click.stop.prevent="goLink(poll.link)">출처</a>
                        </small>
                        <br />
                        <small class="d-none d-lg-block">{{ poll.desc }}</small>
                      </b-col>
                    </b-row>
                  </b-col>
                </template>
              </template>

            </b-row>
          </b-col>
        </b-row>
      </template>
      </template>

    </b-card-body>
    <b-card-footer class="p-0 p-md-1">

    </b-card-footer>
  </b-card>
</template>



<script>
// http://www.ohmynews.com/NWS_Web/View/at_pg_w.aspx?CNTN_CD=A0002623791
// https://github.com/OhmyNews/2020_21_elec_map/blob/master/2020_21_elec_253_simple.json
// https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC
// https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%ED%9B%84%EB%B3%B4%EC%9E%90

const vote21_define = require('./Vote21.Define').default;

const __TOTAL_SEAT = 300;
const __NO_RATIO_SEAT = 253;
const __RATIO_SEAT_CAP = 30;
const __RATIO_SEAT = __TOTAL_SEAT - __NO_RATIO_SEAT;
const __RATIO_SEAT_NO_CAP = __RATIO_SEAT - __RATIO_SEAT_CAP;

const __RATIO_VERY_ENCOUNTER = vote21_define.RATIO_VERY_ENCOUNTER;
const __RATIO_ENCOUNTER = vote21_define.RATIO_ENCOUNTER;

// const polls = require('./polls.json');
// console.log("polls : " + JSON.stringify(polls));
// import local_seat_polls from './localseat.poll'
// console.log(local_seat_polls);

// https://ko.wikipedia.org/wiki/%EB%8C%80%ED%95%9C%EB%AF%BC%EA%B5%AD_%EC%A0%9C21%EB%8C%80_%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90_%EC%84%A0%EA%B1%B0_%EC%97%AC%EB%A1%A0_%EC%A1%B0%EC%82%AC#5%EC%B0%A8_%EC%A0%95%EA%B3%84_%EA%B0%9C%ED%8E%B8_%EC%9D%B4%ED%9B%84_2
const localcodes = require('./localseat.code.json');
const local_seat_candidate = require('./localseat.candidate').default;
const proportional_seat_poll_list = require('./proportional.poll.json');
const local_seat_polls = require('./localseat.poll').default;
const local_seat_final = require('./localseat.final').default;

const local_seat_exitpoll = require('./localseat.exitpoll').default;



// import { Vote21Chart } from './Vote21Chart'
const Vote21Map = require('./Vote21.Map').default;
const Vote21Chart = require('./Vote21.Chart').default;
const Vote21Fire = require('./Vote21.Fire').default;
const Vote21RatioBar = require('./Vote21.RatioBar').default;
const Vote21Award = require('./Vote21.Award').default;


export default {
  components: {
    // DialogHeader,
    "vote21-chart" : Vote21Chart,
    "vote21-map" : Vote21Map,
    "vote21-fire" : Vote21Fire,
    "vote21-ratio-bar" : Vote21RatioBar,
    "vote21-award" : Vote21Award
  },
  data() {
    return {
      partyGroup : {
        jinbo : {name : "진보", color:"#004EA2"},
        veryjinbo : {name : "급진보", color:"#FFCA05"},
        bosoo : {name : "보수", color:"#EF426F"},
        jungdo : {name : "중도", color:"#0BA95F"},
        etcs : {name : "기타", color:"#BBBBBB"},
      },
      partyKey : [
        "theminjoo", "unitedfuture", "minsaengdang", "futurekorea", "platformparty", "justice21", 
        "ourrepublican", "minjung", "koreaeconomy", "people21", "proparknew", "openminjoo", 
        "etcparty", "noparty", "undecided"
      ],
      partyList : {
        theminjoo : {name: "더불어민주당", no:1, localLock:false, ratioLock:true, group:"jinbo", color:"#004EA2"},
        unitedfuture : {name: "미래통합당", no:2, localLock:false, ratioLock:true, group:"bosoo", color:"#EF426F"},
        minsaengdang : {name: "민생당", no:3, localLock:false, ratioLock:false, group:"jungdo", color:"#0BA95F"},
        futurekorea : {name: "미래한국당", no:4, localLock:true, ratioLock:false, group:"bosoo", color:"#EF426F"},
        platformparty : {name: "더불어시민당", no:5, localLock:true, ratioLock:false, group:"jinbo", color:"#0088D2"},
        justice21 : {name: "정의당", no:6, localLock:false, ratioLock:false, group:"veryjinbo", color:"#FFCA05"},
        ourrepublican : {name: "우리공화당", no:7, localLock:false, ratioLock:false, group:"bosoo", color:"#009900"},
        minjung : {name: "민중당", no:8, localLock:false, ratioLock:false, group:"veryjinbo", color:"#F47920"},
        koreaeconomy : {name: "한국경제당", no:9, localLock:true, ratioLock:false, group:"bosoo", color:"#009900"},
        people21 : {name: "국민의당", no:10, localLock:true, ratioLock:false, group:"jungdo", color:"#EA5504"},
        proparknew : {name: "친박신당", no:11, localLock:false, ratioLock:false, group:"bosoo", color:"#BBBBBB"},
        openminjoo : {name: "열린민주당", no:12, localLock:true, ratioLock:false, group:"veryjinbo", color:"#004098"},
        etcparty : {name: "기타", localLock:false, ratioLock:false, group:"etcs", color:"#BBBBBB"},
        noparty : {name: "무소속", localLock:false, ratioLock:true, group:"etcs", color:"#AAAAAA"},
        undecided : {name: "무당층", localLock:true, ratioLock:false, group:"etcs", color:"#CCCCCC"},
      },
      local_seat_poll_link : [
        {name : "서울권", update: "2020-04-11 16:58:01", link:"https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%84%9C%EC%9A%B8%EA%B6%8C"},
        {name : "경기권", update: "2020-04-11 02:19:06", link:"https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B2%BD%EA%B8%B0%EA%B6%8C"},
        {name : "인천권", update: "2020-04-11 15:17:33", link:"https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%9D%B8%EC%B2%9C%EA%B6%8C"},
        {name : "강원권", update: "2020-04-13 16:17:08", link:"https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EA%B0%95%EC%9B%90%EA%B6%8C"},
        {name : "충청권", update: "2020-04-13 09:16:44", link:"https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%B6%A9%EC%B2%AD%EA%B6%8C"},
        {name : "전라권", update: "2020-04-12 13:34:33", link:"https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%84%EB%9D%BC%EA%B6%8C"},
        {name : "영남권", update: "2020-04-11 02:15:09", link:"https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%98%81%EB%82%A8%EA%B6%8C"},
        {name : "제주권", update: "2020-04-09 18:54:11", link:"https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EC%97%AC%EB%A1%A0%EC%A1%B0%EC%82%AC/%EC%A0%9C%EC%A3%BC%EA%B6%8C"},
      ],
      input_party:[
        {localseat : 0, ratio: 0}, {localseat : 0, ratio: 0}, {localseat : 0, ratio: 0},
        {localseat : 0, ratio: 0}, {localseat : 0, ratio: 0}, {localseat : 0, ratio: 0},
        {localseat : 0, ratio: 0}, {localseat : 0, ratio: 0}, {localseat : 0, ratio: 0},
        {localseat : 0, ratio: 0}, {localseat : 0, ratio: 0}, {localseat : 0, ratio: 0},
        {localseat : 0, ratio: 0}, {localseat : 0, ratio: 0}, {localseat : 0, ratio: 0},
        {localseat : 0, ratio: 0}, {localseat : 0, ratio: 0}, {localseat : 0, ratio: 0},
        {localseat : 0, ratio: 0}, {localseat : 0, ratio: 0}, {localseat : 0, ratio: 0},
        {localseat : 0, ratio: 0}, {localseat : 0, ratio: 0}, {localseat : 0, ratio: 0},
        {localseat : 0, ratio: 0}, {localseat : 0, ratio: 0}, {localseat : 0, ratio: 0},
        {localseat : 0, ratio: 0}, {localseat : 0, ratio: 0}, {localseat : 0, ratio: 0},
      ],
      vote_result: {
        KBS : {
          localSeat : {
            theminjoo:(139 + 158) / 2,
            unitedfuture:(90 + 109) / 2,
            justice21:(5 + 7) / 2,
            minsaengdang:0,
            noparty:(0 + 7) / 2
          },
          proportionalSeat: {
            theminjoo : 0,
            unitedfuture: 0,
            minsaengdang : 0,
            futurekorea : (17 + 21) / 2,
            platformparty : (16 + 20) / 2,
            justice21 : 0,
            ourrepublican : 0,
            minjung : 0,
            koreaeconomy : 0,
            people21 : (2 + 4) / 2,
            proparknew : 0,
            openminjoo : (1 + 3) / 2,
            etcparty : 0,
            noparty : 0,
            undecided : 0
          }
        },
        MBC : {
          localSeat : {
            theminjoo:(136 + 151) / 2,
            unitedfuture:(98 + 114) / 2,
            justice21:(5 + 6) / 2,
            minsaengdang: 0,
            noparty:(0 + 5) / 2
          },
          proportionalSeat: {
            theminjoo : 0,
            unitedfuture: 0,
            minsaengdang : 0,
            futurekorea : (18 + 19) / 2,
            platformparty : (17 + 19) / 2,
            justice21 : 0,
            ourrepublican : 0,
            minjung : 0,
            koreaeconomy : 0,
            people21 : (3 + 3) / 2,
            proparknew : 0,
            openminjoo : (2 + 2) / 2,
            etcparty : 0,
            noparty : 0,
            undecided : 0
          }
        },
        SBS : {
          localSeat : {
            theminjoo:(137 + 157) / 2,
            unitedfuture:(91 + 111) / 2,
            justice21:(4 + 8) / 2,
            minsaengdang:(0 + 4) / 2,
            noparty:(0 + 7) / 2
          },
          proportionalSeat: {
            theminjoo : 0,
            unitedfuture: 0,
            minsaengdang : 0,
            futurekorea : (16 + 20) / 2,
            platformparty : (16 + 20) / 2,
            justice21 : 0,
            ourrepublican : 0,
            minjung : 0,
            koreaeconomy : 0,
            people21 : (3 + 5) / 2,
            proparknew : 0,
            openminjoo : (0 + 3) / 2,
            etcparty : 0,
            noparty : 0,
            undecided : 0
          }
        },
        // JTBC : {
        //   localSeat : {
        //     theminjoo:140,
        //     unitedfuture:110,
        //     justice21:1,
        //     minsaengdang:0,
        //     noparty:2
        //   },
        //   proportionalSeat: {
        //     theminjoo : 0,
        //     unitedfuture: 0,
        //     minsaengdang : 2.51,
        //     futurekorea : 33.64,
        //     platformparty : 25.26,
        //     justice21 : 10.3,
        //     ourrepublican : 1.79,
        //     minjung : 1.69,
        //     koreaeconomy : 1.27,
        //     people21 : 6.2,
        //     proparknew : 1.02,
        //     openminjoo : 15.22,
        //     etcparty : 1.1,
        //     noparty : 0,
        //     undecided : 0
        //   }
        // },
        FINAL : {
          localSeat : {
            theminjoo: 163,
            unitedfuture: 84,
            justice21: 1,
            minsaengdang: 0,
            noparty: 5
          },
          proportionalSeat: {
            theminjoo : 0,
            unitedfuture: 0,
            minsaengdang : 2.71,      // 758,778
            futurekorea : 33.84,      // 9,441,520
            platformparty : 33.35,    // 9,307,112
            justice21 : 9.67,         // 2,697,956
            ourrepublican : 0.74,     // 208,719
            minjung : 1.05,           // 295,612
            koreaeconomy : 0,
            people21 : 6.79,          // 1,896,719
            proparknew : 0.51,        // 142,747
            openminjoo : 5.42,        // 1,512,763
            etcparty : 5.84,   // 5.84   // 기타 715,425 + 기독자유통일당 513,159 + 여성의당 208,697 + 국가혁명배당금당 200,657
            noparty : 0,
            undecided : 0             // 무효 : 715,425
          }
        } // https://namu.wiki/w/%EC%A0%9C21%EB%8C%80%20%EA%B5%AD%ED%9A%8C%EC%9D%98%EC%9B%90%20%EC%84%A0%EA%B1%B0/%EB%B9%84%EB%A1%80%EB%8C%80%ED%91%9C
      },

      localSeatVote20: {
        theminjoo:110, unitedfuture:105, people21:25, justice21:2, noparty:11
      },
      localSeatVote21Sample1: {
        theminjoo:135, unitedfuture:109, minsaengdang:2, noparty:7
      },
      localSeatVote21Sample2: {
        theminjoo:130, unitedfuture:119, justice21:1, minsaengdang:3, noparty:0
      },
      localSeatVote21Sample3: {
        theminjoo:139, unitedfuture:110, justice21:0, minsaengdang:0, noparty:4
      },

      lastModified : document.lastModified,

      input_localseat_total: 0,
      input_ratio_total: 0,
      input_ratio100_total: 0,
      input_proportional_seat30_total: 0,
      input_proportional_seat17_total: 0,
      input_seat_total: 0,

      ratio100 : {},
      proportional_seat30 : {},
      proportional_seat17 : {},

      localcodes: localcodes,
      // local_seat_polls: local_seat_polls,
      local_seat_candidate: local_seat_candidate,

      summarized_local_seat: {},
      summarized_local_state: {},
      selected_local_seat_poll : null,

      proportional_seat_poll_list : proportional_seat_poll_list,
      summarized_proportional_seat_poll : {},
      selected_proportional_seat_poll : {},

      merged_local_seat_data: {},

      chartData : {
        labels: [],
        datasets: [{}]
      },
      
      groupData : {
        labels: [],
        datasets: [{}]
      },
      chartOptions : {
        // tooltips: {
        //     enabled: false
        // },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
               let sum = 0;
              let dataArr = data.datasets[0].data;
              // console.log(dataArr);
              dataArr.map(data => {
                sum += data;
              });
              
              const value = data.datasets[0].data[tooltipItem.index];
              let percentage = value + ", " + (value * 100 / sum).toFixed(2) + "%";
              return data['labels'][tooltipItem['index']] + ': ' + percentage;
              // return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + '%';
            }
          }
        },
        legend: {
          labels: {
            fontColor: '#ffffff'
          }
        },
        // cutoutPercentage: 80,
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          datalabels: {
            formatter: (value, ctx) => {
              let sum = 0;
              let dataArr = ctx.chart.data.datasets[0].data;
              dataArr.map(data => {
                sum += data;
              });
              let percentage = value + (value * 100 / sum).toFixed(2) + "%";
              return percentage;
            },
            color: '#fff',
          }
        }
      }
    }
  },
  computed: {
  },
  created() {
    this.summaryProportionalSeatPoll();
    this.summaryLocalSeatPoll();
  },
  mounted() {
    if(this.vote_result && this.vote_result.FINAL) {
      this.selectProportionalSeatPoll(this.vote_result.FINAL.proportionalSeat, true);
      this.selectLocalSeatSample(this.vote_result.FINAL.localSeat)
    } else {
      this.selectProportionalSeatPoll(this.summarized_proportional_seat_poll, true);
      this.selectLocalSeatSample(this.summarized_local_seat);
    }
  },

  // http://watch.peoplepower21.org/election/
  methods: {
    showToast(title, message, variant) {
        this.$bvToast.toast(message, {
          title: title,
          variant: variant || "info",
          toaster: "b-toaster-top-center",
          solid: true
        });
    },

    clazz(type, extra) {
      const ret = [];
      if(type === 1) {
        ret.push(...["col-12", "col-sm-6", "col-md-4", "col-lg-3", "col-xl-3"]);
      } else if(type === 2) {
        ret.push(...["col-6", "col-sm-3", "col-md-4", "col-lg-2", "col-xl-2"]);
      } else if(type === 3) {
        ret.push(...["col-3", "col-sm-3", "col-md-3", "col-lg-1", "col-xl-1"]);
      } else if(type === 4) {
        ret.push(...["col-3", "col-sm-3", "col-md-3", "col-lg-2", "col-xl-2"]);
      }
      if(extra) {
        ret.push(...extra);
      }
      return ret;
    },

    makeOpacity(value) {
        // console.log(value);
      if(value) {
        // console.log(value);
        return {opacity : 0.5};
      }
      // return {opacity : 1};
    },

    selectVoteResult(poll) {
      if(poll) {
        this.selectProportionalSeatPoll(poll.proportionalSeat, true);
        this.selectLocalSeatSample(poll.localSeat)
      } else {
        this.showToast("개표결과 정보 없음", "선거일 이전 이거나 개표정보/출구조사 정보가 아직 발표되지 않았습니다.", "danger");
      }
    },

    extendPartyInfo(item) {
      if(item && item.party in this.partyList) {
        item.color = this.partyList[item.party].color;
        item.partyName = this.partyList[item.party].name;
      }
      return item;
    },

    summaryLocalSeatPoll() {
      // 여론조사 합계
      const local_seat_poll_summary = {};
      const local_seat_exitpoll_summary = {};

      let total = 0;
      
      const summarized_local_seat = {};
      const merged_local_seat_data = {};

      const summarized_local_state = {};
      summarized_local_state.encounter = 0;
      summarized_local_state.veryencounter = 0;
      summarized_local_state.elected = 0;
      summarized_local_state.counting = 0;
      summarized_local_state.unknown = 0;

      Object.keys(localcodes).forEach(localcode => {
        let sum_of_local_seat_polls = null;

        const polls = local_seat_polls[localcode];
        if(Array.isArray(polls) && polls.length > 0) {
          // console.log(localcode, localSeatPoll);
          sum_of_local_seat_polls = {};
          polls.forEach(poll => {
            const respondent = poll.respondent;   // 응답자
            // const pollSummary2 = {};
            if(respondent > 0 && Array.isArray(poll.data) && poll.data.length > 0) {
              // console.log(localcode, polls);

              poll.data.forEach(item => {
                const {party, name, ratio} = item;
                const key = party + "-" + name;

                // console.log(party, name, ratio);
                if(ratio >= 0) {
                  const value = ratio * respondent;
                  if(key in sum_of_local_seat_polls) {
                    sum_of_local_seat_polls[key].ratio += ratio;
                    sum_of_local_seat_polls[key].count++;

                    // pollSummary2[key].ratio += value;
                    // pollSummary2[key].respondent += respondent;
                  } else {
                    sum_of_local_seat_polls[key] = {party, name, ratio : ratio, count : 1};
                    // pollSummary2[key] = {party, name, ratio : value, respondent};
                  }
                }
              });
            }
          });
        }

        if(sum_of_local_seat_polls) {
          // console.log(sum_of_local_seat_polls);
          // pollEncounter[localcode] = 0;
          local_seat_poll_summary[localcode] = [];
          
          Object.keys(sum_of_local_seat_polls).forEach(key => {
            const {party, name, ratio, count} = sum_of_local_seat_polls[key];
            const newratio = ratio / count;
            local_seat_poll_summary[localcode].push({party, name, ratio : parseFloat(newratio.toFixed(2))})
          });
        }


        // 출구조사 합계
        let sum_of_local_seat_exitpolls = null;
        const exitpolls = local_seat_exitpoll[localcode];
        if(exitpolls) {
          // const exitpoll_array = [exitpolls.KBS, exitpolls.MBC, exitpolls.SBS, exitpolls.JTBC];
          const exitpoll_array = [exitpolls.KBS, exitpolls.MBC, exitpolls.SBS];

          sum_of_local_seat_exitpolls = {};
          exitpoll_array.forEach(exitpoll => {
            if(exitpoll) {
              exitpoll.forEach(item => {
                const {party, name, ratio} = item;
                const key = party + "-" + name;

                // console.log(party, name, ratio);
                if(ratio >= 0) {
                  if(key in sum_of_local_seat_exitpolls) {
                    sum_of_local_seat_exitpolls[key].ratio += ratio;
                    sum_of_local_seat_exitpolls[key].count++;
                  } else {
                    sum_of_local_seat_exitpolls[key] = {party, name, ratio : ratio, count : 1};
                  }
                }
              });
            }
          });

          if(sum_of_local_seat_exitpolls) {
            // console.log(sum_of_local_seat_exitpolls);
            // pollEncounter[localcode] = 0;
            local_seat_exitpoll_summary[localcode] = [];
            
            Object.keys(sum_of_local_seat_exitpolls).forEach(key => {
              const {party, name, ratio, count} = sum_of_local_seat_exitpolls[key];
              const newratio = ratio / count;
              local_seat_exitpoll_summary[localcode].push({party, name, ratio : parseFloat(newratio.toFixed(2))})
            });
          }
          // if(localcode === "2110101") {
          //   // console.log(exitpoll_array, local_seat_exitpoll_summary[localcode]);
          //   console.log(local_seat_exitpoll_summary[localcode]);
          // }
        }




        // if(localcode === "2110101") {
          let party = "";
          const item = {};
          item.candidate = local_seat_candidate[localcode];
          item.polls = local_seat_polls[localcode];
          item.exitpolls = local_seat_exitpoll[localcode];

          // 여론조사
          let local_encounter = 0;
          if(local_seat_poll_summary && localcode in local_seat_poll_summary) {
            const data = local_seat_poll_summary[localcode];
            const first = this.extendPartyInfo(this.find1st(data));
            const encounter = this.findPollEncounter(data);
            item.poll = {
              data,
              first,
              encounter
            };
            item.first = first;
            item.data = data;
            item.encounter = encounter;
            party = first.party;
            local_encounter = encounter;
          }

          // 출구조사
          if(local_seat_exitpoll_summary && localcode in local_seat_exitpoll_summary) {
            const data = local_seat_exitpoll_summary[localcode];
            const first = this.extendPartyInfo(this.find1st(data));
            const encounter = this.findPollEncounter(data);
            item.exitpoll = {
              data,
              first,
              encounter
            };
            item.first = first;
            item.data = data;
            item.encounter = encounter;
            party = first.party;
            local_encounter = encounter;
          }

          // 개표결과
          if(local_seat_final && localcode in local_seat_final) {
            const data = local_seat_final[localcode];
            const first = this.extendPartyInfo(this.find1st(data));
            const encounter = this.findPollEncounter(data);
            item.final = {
              data,
              first,
              encounter
            };
            item.first = first;
            item.data = data;
            item.encounter = encounter;
            party = first.party;
            local_encounter = encounter;

            let elected = null;
            local_seat_final[localcode].some(item => {
              if(item.elected) {
                elected = this.extendPartyInfo(item);
                return true;
              }
            });
            if(elected) {
              party = elected.party;
              item.elected = elected;
              item.first = elected;
            }
          }
          merged_local_seat_data[localcode] = item;

          // if(localcode === "2110101") {
          //   console.log(item);
          // }

          // 상태 처리
          if(item.elected) {
            summarized_local_state.elected++;
          } else if(local_encounter > 0 && local_encounter <= __RATIO_VERY_ENCOUNTER) {
            summarized_local_state.veryencounter++;
          } else if(local_encounter > 0 && local_encounter <= __RATIO_ENCOUNTER) {
            summarized_local_state.encounter++;
          } else if(local_encounter > 0) {
            summarized_local_state.counting++;
          } else {
            summarized_local_state.unknown++;
          }


          // 정당별 지역구 득표수 종합
          if(party) {
            if(party in summarized_local_seat) {
              summarized_local_seat[party]++;
            } else {
              summarized_local_seat[party] = 1;
            }
            total++;
          }

          
          // local_encounter
        // }
      });

      summarized_local_seat["undecided"] = __NO_RATIO_SEAT - total;
      this.summarized_local_seat = summarized_local_seat;
      this.summarized_local_state = summarized_local_state;

      // console.log("정당별 지역구 당선자 합계", summarized_local_seat);

      // console.log("지도정보", merged_local_seat_data);
      this.merged_local_seat_data = merged_local_seat_data;
    },

    summaryProportionalSeatPoll() {
      const sum = {};
      this.proportional_seat_poll_list.forEach(item => {
          const respondent = item.respondent;   // 응답자
          Object.keys(item).forEach(key => {
            if(key !== "requester" && key !== "research" && key !== "period" && key !== "respondent") {
              const ratio = item[key];
              if(ratio >= 0) {
                const value = ratio * respondent;
                if(key in sum) {
                  sum[key].ratio += value;
                  sum[key].respondent += respondent;
                } else {
                  sum[key] = {ratio : value, respondent};
                }
              }
            }
          })
      });
      
      const summary = {};
      // console.log("proportional_seat_poll_list Sum : ", sum);

      let respondent = 0;
      Object.keys(sum).forEach(key => {
        summary[key] = sum[key].ratio / sum[key].respondent;
        if(key === "undecided") {
          respondent = sum[key].respondent;
        }
      });

      // console.log("proportional_seat_poll_list Summary : ", summary);

      this.summarized_proportional_seat_poll = summary;
      this.summarized_proportional_seat_poll.respondent = respondent;
    },

    readLocalSeat(index) {
      if(this.input_party[index] && this.input_party[index].localseat) {
        return parseFloat(this.input_party[index].localseat);
      }
      return 0;
    },
    seatRatio(index, key) {
      return (parseFloat(this.input_party[index].localseat) + (this.proportional_seat30[key] || 0) + (this.proportional_seat17[key] || 0))/300 * 100;
    },
    redistribute(amount, redistributeRatio) {
        const ret = {};
        let ratioSum = 0;
        Object.keys(redistributeRatio).forEach(key => {
          const data = redistributeRatio[key];
          if(data) {
            // console.log(key + " => " + data);
            ratioSum += data;
          }
        });
        // console.log("재배분 비율합계 : " + ratioSum);


        // 재배분 1단계
        let step1sum = 0;
        let remains = {};
        const share_party_list = [];
        // console.log("1차 배분");
        Object.keys(redistributeRatio).forEach(key => {
          const data = redistributeRatio[key];
          if(data) {
            const redata = data * amount / ratioSum;
            const relocalseat = Math.floor(redata);

            // remains[key] = redata - relocalseat;
            // console.log("\t", this.partyList[key].name, relocalseat + " => " + remains[key]);

            // console.log("\t", this.partyList[key].name, relocalseat);
            share_party_list.push({key:key, value: redata - relocalseat});

            ret[key] = relocalseat;
            step1sum += relocalseat;
          } else {
            ret[key] = 0;
          }
        });

        const rest_localseat = amount-step1sum;
        // console.log("1차 배분 합계 : " + step1sum);
        // console.log("1차 배분 후 남은 의석수 : " + rest_localseat);

        const filled = this.fillRest(share_party_list, rest_localseat);
        Object.keys(filled).forEach(key => {
          ret[key] += filled[key];
        });

        return ret;

    },
    fillRest(share_party_list, amount) {
      share_party_list.sort(function(a, b) {
        // 내림차순
        return b.value - a.value;
        // 44, 25, 21, 13
      });

      // console.log("소수점 배분 순서");
      // share_party_list.forEach(party => {
      //   console.log("\t", this.partyList[party.key].name, party.value);
      // });

      var share_party_count = share_party_list.length;
      // console.log("비례배분 정당 수:", share_party_count);

      const second_share = {};
      for (var i = 1; i < amount + 1; i++) {
        let temp = i % share_party_count;
        temp = (temp == 0) ? share_party_count : temp;

        const party_index = temp - 1;
        const party = share_party_list[party_index].key;

        // console.log("비례배분 : ", party_index, JSON.stringify(share_party_list[party_index]))
        if(second_share[party]) {
          second_share[party]++;
        } else {
          second_share[party] = 1;
        }
        //console.log(temp, share_party_list[party_key].party);
      }
      // console.log("비례배분 : " + JSON.stringify(second_share))
      return second_share;
    },
    firstCome(list, amount) {
      if(amount <= 0) return [];

      let firstParty = "";
      let partyValue = 0;

      Object.keys(list).forEach(key=> {
        if(partyValue <= list[key]){
          firstParty = key;
          partyValue = list[key];
        }
      });

      const ret = [];
      ret.push(firstParty);
      if(amount > 1) {
        delete list[firstParty];
        const nextParty = this.firstCome(list, amount - 1);
        ret.push(...nextParty);
      }

      return ret;
    },

    selectProportionalSeatPoll(poll, ignoreCalcuate) {
      // summarized_proportional_seat_poll
      // selected_proportional_seat_poll
      // console.log("selectProportionalSeatPoll", poll);
      this.selected_proportional_seat_poll = poll;

      this.partyKey.forEach((key, index) => {
        // console.log(key, index);
        if(poll.hasOwnProperty(key) && poll[key] > 0) {
          const ratio = parseFloat(poll[key]) || 0;
          this.input_party[index].ratio = ratio.toFixed(2);
        } else {
          this.input_party[index].ratio = 0;
        }
      });

      if(!ignoreCalcuate) this.calculate();
    },
    
    selectLocalSeatSample(sample) {
      // console.log("지역구의석 재배분", sample);

      const local_seat_ratio = {};
      Object.keys(this.partyList).forEach(key => {
        const party = this.partyList[key];
        const data = sample[key];

        if(data) {
          // console.log("\t", party.name, data);
          // 지역구를 내지 않는 경우는 제외
          if(data && !party.localLock) {
            local_seat_ratio[key] = data;
          }
        }
      });

      const redistribute_local_seats = this.redistribute(__NO_RATIO_SEAT, local_seat_ratio);

      // console.log("지역구의석 재배분");
      this.partyKey.forEach((key, index) => {
        // const party = this.partyList[key];
        const seats = (key in redistribute_local_seats) ? redistribute_local_seats[key] : 0;
        if(this.input_party[index]) {
          this.input_party[index].localseat = seats;
        }
        // console.log("\t", this.partyList[key].name, seats);
      });

      this.calculate();
    },

    calculate() {
      // console.log("....................calculate....................");
      // console.log("입력양식 초기화");
      let totalLocalSeat = 0;
      this.partyKey.forEach((key, index) => {
        const party = this.partyList[key];
        // this.selectedPoll.data[key] = this.selectedPoll.data[key] || {localseat:0, ratio: 0};
        const localseat = parseFloat(this.input_party[index].localseat) || 0;
        const ratio = parseFloat(this.input_party[index].ratio) || 0;

        totalLocalSeat += localseat;
        // console.log("\t", this.partyList[key].name, localseat, ratio);
      });
      this.input_localseat_total = totalLocalSeat;



      let baseSeat = __TOTAL_SEAT;
      const ratioSeatPartyList = [];
      let ratioSum = 0;
      // Object.keys(this.selectedPoll.data).forEach(key => {
      //   const data = this.selectedPoll.data[key];
      //   ratioSum += data.ratio;
      // });
      this.partyKey.forEach((key, index) => {
        const ratio = parseFloat(this.input_party[index].ratio) || 0;
        const localSeat = parseFloat(this.input_party[index].localseat) || 0;
        if(key !== "undecided" && key !== 'etcparty' && key !== 'noparty' && (ratio >= 3 || localSeat >= 5)) {
          ratioSum += parseFloat(ratio.toFixed(1));
          ratioSeatPartyList.push(key);
        } else {
          baseSeat -= localSeat;
        }
      });
      this.input_ratio_total = ratioSum.toFixed(1);
      // console.log("비례배분 정당:", ratioSeatPartyList);
      // console.log("비례대표 연동대상 : " + baseSeat);
      // console.log("전체 정당지지율 합계 : " + ratioSum);






      let rescaled_ratio_sum = 0;
      // console.log("정당 환산 지지율");
      this.partyKey.forEach((key, index) => {
        //const party = this.partyList[key];
        const ratio = parseFloat(this.input_party[index].ratio) || 0;
        const localSeat = parseFloat(this.input_party[index].localseat) || 0;
        const reratio = parseFloat(ratio * 100 / ratioSum.toFixed(1));
        // delete this.ratio100[key];

        if(key !== "undecided" && key !== 'etcparty' && key !== 'noparty' && (ratio >= 3 || localSeat >= 5)) {
          this.ratio100[key] = reratio;
          rescaled_ratio_sum += reratio;
        } else {
          this.ratio100[key] = 0;
        }
        // console.log("\t", this.partyList[key].name, this.ratio100[key]);
      });
      
      // this.input_ratio100_total = rescaled_ratio_sum.toFixed(1);
      // console.log("무당층 제외 정당 지지율 100%로 재계산 : " + rescaled_ratio_sum);








      // // extraSeat += this.selectedPoll.data['noparty'].localseat;
      // const minus_seat_table = {};
      // const ratioSeatPartyList1 = [];
      // // console.log("연동배분 의석수 계산 및 비례배분 정당");
      // this.partyKey.forEach((key, index) => {
      //   const party = this.partyList[key];
      //   const ratio = this.ratio100[key] || 0;
      //   // const localSeat = this.selectedPoll.data[key].localseat || 0;
      //   const localSeat = parseFloat(this.input_party[index].localseat) || 0;

      //   // 정당득표율 0이 아니고(and),  (득표율 3% 이상  or  지역구 5석 이상인 경우)에만    비례할당 정당 리스트(ex_list)에 추가
      //   // 무소속의석과, 득표율 3% 미만 and  지역구 5명 미만인 정당의 지역구 의석은  전체의석에서 빼서, 연동배분기준의석수(base_localseat) 산출
      //   // 3% 또는 5석 이상 정당만
      //   if(key === 'noparty') {
      //     // extraSeat += this.selectedPoll.data[key].localseat;
      //       minus_seat_table[key] = localSeat;
      //   } else if(ratio >= 3 || localSeat >= 5) {
      //     if(key !== "etcparty") ratioSeatPartyList1.push(key);
      //     if(ratio > 0) {
      //       minus_seat_table[key] = 0;
      //     } else {
      //       minus_seat_table[key] = localSeat;
      //     }
      //   } else {
      //     // minus_seat_table[key] = this.selectedPoll.data[key].localseat;
      //     minus_seat_table[key] = localSeat;
      //   }
      //   // console.log("\t", party.name, ratio, minus_seat_table[key]);
      //   baseSeat -= minus_seat_table[key];
      // });
      
      // delete ratioSeatPartyList.etcparty;
      // // console.log("1.연동배분 기준 의석수:", baseSeat);
      // // console.log("비례배분 정당:", ratioSeatPartyList);





      // console.log("병립형 비례 :", __RATIO_SEAT_NO_CAP);
      const ratio100 = JSON.parse(JSON.stringify(this.ratio100));
      Object.keys(ratio100).forEach(key => {
        if(!ratioSeatPartyList.includes(key)) {
          delete ratio100[key];
        }
      });
      delete ratio100["etcparty"];
      this.ratio100 = ratio100;
      // console.log("비례배분 대상 비율:", ratio100);





      this.proportional_seat17 = {};
      let proportional_seat17sum = 0;
      const proportional_seat17 = this.redistribute(__RATIO_SEAT_NO_CAP, ratio100);
      Object.keys(proportional_seat17).forEach(key => {
        this.proportional_seat17[key] = proportional_seat17[key];
        proportional_seat17sum += proportional_seat17[key];
        // console.log("\t", this.partyList[key].name, this.proportional_seat17[key]);
      });
      this.input_proportional_seat17_total = proportional_seat17sum;
      // console.log("병립형 비례 :", JSON.stringify(this.proportional_seat17));





      let first_share_total = 0;
      const first_share = {};
      const first_share_base_num = {};
      // console.log("2.정당별 배분기초수치")
      this.partyKey.forEach((key, index) => {
        const party = this.partyList[key];
        // const localSeat = this.selectedPoll.data[key].localseat || 0;
        const localSeat = parseFloat(this.input_party[index].localseat) || 0;
        if(ratioSeatPartyList.includes(key) && key !== 'party' && key !== 'noparty' && key !== 'undecided') {
          const fsbn = ((baseSeat * this.ratio100[key]) / 100 - localSeat) / 2;

          first_share_base_num[key] = fsbn;

          // 3.연동비례 1차 배분   first_share_i
          //   반올림 후 정수 배분
          first_share[key] = 0;
          if (Math.round(fsbn) < 1) {
            first_share[key] = 0;
          } else {
            first_share[key] = Math.round(fsbn);
            first_share_total += first_share[key];
            // console.log("\t", party.name, first_share[key]);
          }
        }
      });
      
      // console.log("정수 할당할 정당 :", first_share_party_list);
      // console.log("1차 배분 합계:", first_share_total);
      // console.log(
      //   "3.정당별 연동비례 1차 배분(정수배분):", JSON.stringify(first_share),
      //   "합계:", first_share_total
      // );





      // first_share_total = 35;
      if(first_share_total === __RATIO_SEAT_CAP) {
        // console.log("준연동 비례배분");
        this.partyKey.forEach((key, index) => {
          this.proportional_seat30[key] = first_share[key] || 0;
          // console.log("\t", this.partyList[key].name, this.proportional_seat30[key] || 0);
        });
      } else if (first_share_total > __RATIO_SEAT_CAP) {
        // console.log("1차 배분 30 초과한  경우");
        //30 초과한 경우   1차 배분 다시 계산
        //1. 배분위한 기초 수치 다시 계산

        // console.log("1차  재배분 기초 수치")
        const first_share = {};
        let new_first_share_total = 0;
        let share_party_list = [];
        this.partyKey.forEach((key, index) => {
          if(ratioSeatPartyList.includes(key) && key !== 'party' && key !== 'noparty' && key !== 'undecided') {
            const party = this.partyList[key];
            if(first_share_base_num[key] && first_share_base_num[key] > 0) {
              const fsbn = first_share_base_num[key];
              const num = (__RATIO_SEAT_CAP * fsbn) / first_share_total;
              const localseat = Math.floor(num);

              first_share[key] = localseat;
              share_party_list.push({key:key, value:num - localseat});

              new_first_share_total += localseat;

              // console.log("\t", party.name, num, localseat);
            }
          }
        });

        rest_localseat = __RATIO_SEAT_CAP - new_first_share_total;
        // console.log("남은 의석 : ", rest_localseat)

        const second_share = this.fillRest(share_party_list, rest_localseat);

        // console.log("2차 비례배분");
        // Object.keys(second_share).forEach(key => {
        //   console.log("\t", this.partyList[key].name, second_share[key]);
        // });

        // console.log("준연동 비례배분");
        let seat30sum = 0;
        this.partyKey.forEach((key, index) => {
          this.proportional_seat30[key] = (first_share[key] || 0) + (second_share[key] || 0);
          seat30sum += this.proportional_seat30[key];
          // console.log("\t", this.partyList[key].name, this.proportional_seat30[key] || 0);
        });
        this.input_proportional_seat30_total = seat30sum;
      } else {
        //first_share_total 30보다 작은경우

        // console.log("1차 배분 30 이하인 경우");
        var rest_localseat = __RATIO_SEAT_CAP - first_share_total; // 1차 배분후 남은 의석 - 소수점이하 숫자기준 배분함
        //ex_list2  사용해서 나머지 배분

        // console.log("1차 배분 후 남은 의석수: ", rest_localseat);
        //1차배분후 남은 의석 배분 ex) rest_localseat =6

        const second_share = this.redistribute(rest_localseat, this.ratio100);

        // console.log("1차 배분 최종(정수+소수배분):", JSON.stringify(first_share));
        // console.log("2차 배분 최종(정수+소수배분):", JSON.stringify(second_share));
        
        // console.log("준연동 비례배분");
        let seat30sum = 0;
        this.partyKey.forEach((key, index) => {
          if(ratioSeatPartyList.includes(key) && key !== 'party' && key !== 'noparty' && key !== 'undecided') {
            const party = this.partyList[key];
            this.proportional_seat30[key] = (first_share[key] || 0) + (second_share[key] || 0);
            seat30sum += this.proportional_seat30[key];
            // console.log("\t", this.partyList[key].name, this.proportional_seat30[key] || 0);
          }
        });
        this.input_proportional_seat30_total = seat30sum;
      }


      console.log("정당별 의석수");
      let seatTotal = 0;
      const party_chart_label = [];
      const party_chart_color = [];
      const party_chart_data = [];

      const party_group_dataset = {};
      this.partyKey.forEach((key, index) => {
        const party = this.partyList[key];
        let num = (this.readLocalSeat(index) + (this.proportional_seat30[key] || 0) + (this.proportional_seat17[key] || 0));
        seatTotal += num || 0;

        // console.log("\t", party.name, this.readLocalSeat(index), this.proportional_seat30[key], this.proportional_seat17[key]);
        console.log("\t", party.name, num || 0);

        party_chart_label.push(party.name);
        party_chart_color.push(party.color);
        party_chart_data.push(num || 0);

        if(party_group_dataset[party.group]) {
          party_group_dataset[party.group] += num || 0;
        } else {
          party_group_dataset[party.group] = num || 0;
        }
      });
      this.input_seat_total = seatTotal;

      this.chartData.labels = party_chart_label;
      this.chartData.datasets[0].backgroundColor = party_chart_color;
      this.chartData.datasets[0].data = party_chart_data;


      const party_group_label = [];
      const party_group_color = [];
      const party_group_data = [];
      Object.keys(party_group_dataset).forEach(key => {
        const group = this.partyGroup[key];
        party_group_label.push(group.name);
        party_group_color.push(group.color);
        party_group_data.push(party_group_dataset[key]);
      });

      this.groupData.labels = party_group_label;
      this.groupData.datasets[0].backgroundColor = party_group_color;
      this.groupData.datasets[0].data = party_group_data;

      this.updateChart();
    },

    updateChart () {
      this.$refs.party_group_chart.update();
      this.$refs.party_seat_chart.update();
    },

    goLink(url) {
      window.open(url, "_blank");
    },



    find1st(data) {
      const cloned = JSON.parse(JSON.stringify(data));
      if(cloned && Array.isArray(cloned) && cloned.length > 0) {
        // console.log(zone);
        let candidate1st = "";
        let maxRatio = 0;
        
        cloned.forEach(item => {
          if(maxRatio < parseFloat(item.ratio)) {
            maxRatio = parseFloat(item.ratio);
            candidate1st = item;
          }
        });
        
        return candidate1st;
      }
      return null;
    },
    findPollEncounter(data) {
      // console.log("findPollEncounter", zone);
      // const zone = poll["" + code];
      const cloned = JSON.parse(JSON.stringify(data));
      if(cloned && Array.isArray(cloned) && cloned.length > 0) {
          cloned.sort(function(a, b) {
            // 내림차순
            return b.ratio - a.ratio;
            // 44, 25, 21, 13
          });

          if(cloned.length >= 2) {
            return cloned[0].ratio - cloned[1].ratio;
          }
      }
      return 0;
    },
  }
}
</script>

<style scoped>
.col-poll {
  position:relative;
}
.col-group, .col-badge, .col-label, .col-percent {
  position:absolute;
  margin-top:-7px;
  margin-left:-5px;
}
.col-label {
  margin-left: 1px;
}
.col-percent {
  margin-left: -20px;
}
.col-badge {
  margin-left:-60px;
}
.form-control{
  padding: 0.3rem 0.3rem;
  height: initial;
}
.meaning {
  color: #ffffff;
}
.hover-row:hover {
  background-color: #73818f;
}
.poll-hover-row:hover {
  background-color: #656A6E;
}

</style>
